import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthStateService } from '../services/auth-state.service';

@Directive({
  selector: '[withRight]'
})
export class WithRightDirective implements OnInit {

  @Input() withRight: string = null;

  constructor(
    private auth: AuthStateService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    if (!this.auth.hasRight(this.withRight)) {
      if (this.elementRef.nativeElement.style) {
        this.elementRef.nativeElement.style.display = 'none';
      }
    }
  }

}
